import { Box, TextField, Typography } from '@mui/material';
import { ChangeEvent } from 'react';

interface AIOOutcomeNotesProps {
  notes: string;
  handleNotesChange: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  maxNotesLength: number;
}

export const AIOOutcomeNotes = ({
  notes,
  handleNotesChange,
  maxNotesLength,
}: AIOOutcomeNotesProps) => {
  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <Typography
        variant="h6"
        component="label"
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 500,
          fontSize: 18,
          color: 'black',
          mb: 1,
          display: 'block',
        }}
      >
        Notes
      </Typography>
      <TextField
        multiline
        rows={4}
        fullWidth
        placeholder="Optional notes"
        value={notes}
        onChange={handleNotesChange}
        inputProps={{ maxLength: 1500 }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2.5,
            fontFamily: 'DM Sans',
            fontWeight: 500,
            fontSize: 16,
            '& fieldset': {
              borderColor: 'black',
              borderWidth: 1,
            },
            '&:hover fieldset': {
              borderColor: 'black',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'black',
              borderWidth: 2,
            },
          },
          '& .MuiInputBase-input': {
            '&::placeholder': {
              color: '#8E8E8E',
              opacity: 1,
            },
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          fontFamily: 'DM Sans',
          fontWeight: 500,
          fontSize: 12,
          color: notes.length > maxNotesLength ? 'red' : 'black',
          display: 'block',
          textAlign: 'right',
          mt: 1,
        }}
      >
        {notes.length}/{maxNotesLength} characters
      </Typography>
    </Box>
  );
};
